import React, { ReactNode } from 'react'

import { RoleTone } from '../../constants'

import { ProgressFill, ProgressTrack } from './styles'

interface ProgressProps {
  value: number
  max?: number
  label: string
  tone?: RoleTone
  size?: 'small' | 'medium'
  marker?: ReactNode
  variant?: 'solid' | 'celebration'
}

const Progress = ({
  label,
  marker,
  max = 100,
  size = 'small',
  tone = 'student',
  value,
  variant = 'solid',
}: ProgressProps) => {
  const safeMax = Math.max(1, max)
  const safeValue = Math.min(Math.max(0, value), safeMax)
  const percentage = (safeValue / safeMax) * 100

  return (
    <ProgressTrack
      role="progressbar"
      aria-label={label}
      aria-valuemin={0}
      aria-valuemax={safeMax}
      aria-valuenow={safeValue}
      $size={size}
    >
      <ProgressFill
        $progress={percentage}
        $tone={tone}
        $hasMarker={!!marker}
        $variant={variant}
      >
        {marker && <span aria-hidden="true">{marker}</span>}
      </ProgressFill>
    </ProgressTrack>
  )
}

export default Progress
